if (!customElements.get("faq-tabs")) {
    class Tabs extends HTMLElement {
        constructor() {
            super();
            this.tabs = this.querySelectorAll(".td-tab");
        }
        connectedCallback() {
            this.bindEvents();
        }
        
        bindEvents() {
            const el = this;
            this.tabs.forEach(function (tab) {
                tab.addEventListener("click", function (event) {
                    el.toggle(tab.dataset.item);
                });
            })
        }

        toggle(currentItem) {
            const el = this;
            this.tabs.forEach(function (tab) {
                if (tab.dataset.item == currentItem) {
                    if (tab.classList.contains("td-active-tab")) {
                        return
                    }
                    tab.classList.toggle("td-active-tab");
                } else {
                    tab.classList.remove("td-active-tab");
                }
            });
          }
    }
  
    customElements.define("faq-tabs", Tabs);
}
  